// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Error(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Error" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2 1.5L22.5 7.8V16.2L16.2 22.5H7.8L1.5 16.2V7.8L7.8 1.5H16.2ZM10.5 5.625H13.5V12.75H10.5V5.625ZM12 18.375C13.0355 18.375 13.875 17.5355 13.875 16.5C13.875 15.4645 13.0355 14.625 12 14.625C10.9645 14.625 10.125 15.4645 10.125 16.5C10.125 17.5355 10.9645 18.375 12 18.375Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Error.js.map